
import { useMutation } from "react-query"
import { useToast } from "../../hook/usetoast";
import DataService from '../../config/DataServices'

const { postRequest} = DataService()






export const useLogin = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/login", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}


export const useLoginVerifyOTP = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/verify-login", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}


export const useRegisterVerify = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: id => {
            return postRequest("user/verify-register", id)
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}

export const useForgotPassword = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/forgot-password", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}

export const useResetPassword = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/reset-password", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}

export const useLogOut = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/logout", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}